import React from "react";
import { Outlet } from "react-router-dom";
import { MENU_SLUG } from "../constants/constants";
import Logo from "../components/logo";
import Nav from "../components/nav";
import styles from "./style.module.css";

const Layout = ({ pages }) => {
  return (
    <div className={styles.layout}>
      <div className={styles.layout_inner}>
        <div className={styles.sidebar}>
          <div className={styles.sidebar_inner}>
            <div className={styles.sidebar_logo}>
              <Logo link={`/${MENU_SLUG.snapshot}`} />
            </div>
            <Nav pages={pages} />
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.body_inner}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
